export default __webpack_public_path__ + "880c8e91d79437f3ffa8edcd9f90734f.png";